import { useContext } from 'react';
import isNull from 'lodash/isNull';
import { AppContext } from './AppContext';
import { DATA_URL } from './FarmContext';

const ownerTransferSource = {
  "tiles": [
    "https://tileserver-sx3ktfshsq-uc.a.run.app/services/ownertransfer/tiles/{z}/{x}/{y}.pbf"
  ],
  "maxzoom": 14,
  "minzoom": 5,
  "type": "vector",
}

const ownerTransferLine = {
    id: 'ownertransfer-line',
    type: 'line',
    'source-layer': 'ownertransfer',
    source: 'ownertransfer',
  	maxzoom: 22,
  	minzoom: 5,
  	paint: {
    	"line-color": "white",
    	"line-width": 2
  	}
}

const ownerTransferFill = {
    id: 'ownertransfer-fill',
    type: 'fill',
    'source-layer': 'ownertransfer',
    source: 'ownertransfer',
  	maxzoom: 22,
  	minzoom: 5,
  	paint: {
    	"fill-color": "transparent"
  	}
}


function PopupContents ({ properties }) {
  return <div>
    {Object.entries(properties)
      .filter(([k, v]) => !isNull(v))
      .map(([k, v]) => {
      return <div key={k}> <span className="text-xs"> {k} </span>: {v} </div>
    })}
  </div>
}


export function SidebarContents () {
  const { selectedCorelogic, loadingCorelogic } = useContext(AppContext);
  if (!selectedCorelogic) return null;
  return <div className="p-4 h-screen overflow-y-auto">
    <div> 
      <h3 className="text-lg leading-6 font-medium text-gray-900">Courthouse Comp</h3>
    </div>
    <PopupContents properties={selectedCorelogic} />
    {loadingCorelogic && <div> Loading more ... </div>}
  </div>
}


async function onClick(e, setSelectedCorelogic, setLoadingCorelogic) {
  // const map = e.target;
  // var coordinates = e.features[0].geometry.coordinates.slice();

  // Ensure that if the map is zoomed out such that
  // multiple copies of the feature are visible, the
  // popup appears over the copy being pointed to.
  // while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
  //     coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
  // }
  // const coordinates = e.lngLat;

  // const placeholder = document.createElement('div');
  const feature = e.features[0];

  setLoadingCorelogic(true);
  setSelectedCorelogic(feature.properties);

  const transfer_id = feature['properties']['id'];
  
  const ownertransfer = await fetch(DATA_URL + `/ownertransfer/${transfer_id}`)
    .then(r => r.json());

  const parcel_id = feature['properties']['ONLINE FORMATTED PARCEL ID'];
  
  const propertybasic = await fetch(DATA_URL + `/propertybasic/${parcel_id}`)
    .then(r => r.json());

  setSelectedCorelogic({...propertybasic, ...ownertransfer,  ...feature.properties})
  setLoadingCorelogic(false);
  
  // ReactDOM.render(<PopupContents properties={feature.properties} />, placeholder);
  // ReactDOM.render(<PopupContents properties={{...propertybasic, ...ownertransfer,  ...feature.properties}} />, placeholder);

  // new mapboxgl.Popup()
  //     .setLngLat(coordinates)
  //     .setDOMContent(placeholder)
  //     .addTo(map);
}

export function useCoreLogicOwnerTransfer() {
  const { mapboxRef, setSelectedCorelogic, setLoadingCorelogic } = useContext(AppContext);
	const coreLogicToggle = (toggle) => {

		if (!mapboxRef.current.getSource('ownertransfer')) mapboxRef.current.addSource('ownertransfer', ownerTransferSource);
		[ownerTransferLine, ownerTransferFill].forEach(l => {
	 	 	if (mapboxRef.current.getLayer(l.id)) mapboxRef.current.removeLayer(l.id);
		    if (toggle) {
		        mapboxRef.current.addLayer(l);
		    }
		})
		
		mapboxRef.current.off('click', ownerTransferFill.id);
		if (toggle) {
			mapboxRef.current.on('click', ownerTransferFill.id, evt => onClick(evt, setSelectedCorelogic, setLoadingCorelogic));
		}


	}
	return {
		coreLogicToggle
	}
}